import { useNavigate } from "react-router-dom";
import "./Properties.css";
import { formatDistanceToNow } from "date-fns";
import { FiEdit, FiTrash2, FiEye, FiPlus } from "react-icons/fi";
import { useEffect, useState } from "react";
import convertAmount from "../../utils/convertAmount";
import apis from "../../utils/apis";
import httpAction from "../../utils/httpAction";
import { useDispatch } from "react-redux";
import { ediiActions } from "../../redux/edit-slice";
import toast from "react-hot-toast";
import { FaGripfire } from "react-icons/fa";

export default function Properties() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [row, setRow] = useState([]);

  const getPropertyList = async () => {
    const data = {
      url: apis().propertyList,
    };
    const result = await httpAction(data);
    if (result?.status) {
      setRow(result?.list);
    }
  };

  useEffect(() => {
    getPropertyList();
  }, []);

  const editHandler = (item) => {
    dispatch(ediiActions.setProperty(item));
    navigate("/admin/properties/add?id=" + item?._id);
  };

  const deleteHandler = async (item, index) => {
    const data = {
      url: apis().deleteListing + "?id=" + item?._id,
      method: "DELETE",
    };
    const result = await httpAction(data);
    if (result?.status) {
      toast.success(result?.message);
      const copyItems = [...row];
      copyItems.splice(index, 1);
      setRow(copyItems);
    }
  };

  const markHotHandler = async (prop, index) => {
    const data = {
      url: apis().listingMarkHot + "?id=" + prop?._id,
      method: "PUT",
    };
    const result = await httpAction(data);
    if (result?.status) {
      toast.success(result?.message);
      const copyRow = [...row];
      copyRow.splice(index, 1, result?.listing);
      setRow(copyRow);
    }
  };

  return (
    <div className="admProp">
      {/* Header */}
      <div className="admProp__head">
        <div>
          <h2 className="admProp__title">Properties</h2>
          <p className="admProp__sub">Manage all listed properties here</p>
        </div>

        <button
          onClick={() => {
            navigate("/admin/properties/add");
          }}
          className="admProp__add"
        >
          <FiPlus /> Add Property
        </button>
      </div>

      {/* Table */}
      <div className="admProp__tableWrap">
        <table className="admProp__table">
          <thead>
            <tr>
              <th>#</th>
              <th>Property Title</th>
              <th>Address</th>
              <th>Price</th>
              <th>Type</th>
              <th>Size</th>
              <th>Listed</th>
              <th>Visits</th>
              <th>Calls</th>
              <th>User</th>
              <th className="text-end">Actions</th>
            </tr>
          </thead>

          <tbody>
            {row?.map((p, i) => (
              <tr key={p._id}>
                <td>{i + 1}</td>
                <td
                  className="fw-bold d-inline-block text-truncate"
                  style={{ maxWidth: "140px" }}
                >
                  {p?.data?.title}
                </td>
                <td>{p?.data?.location}</td>
                <td>
                  <span style={{ color: "gray" }}>PKR:</span>{" "}
                  {convertAmount(p?.data?.price)}
                  {p?.data?.type === "project" && (
                    <span style={{ color: "gray" }}>/SQ.FT</span>
                  )}
                </td>
                <td>
                  <span className={`status status--${p?.data?.type}`}>
                    {p?.data?.type}
                  </span>
                </td>
                <td>{p?.data?.size}</td>
                <td>
                  {formatDistanceToNow(new Date(p?.createdAt), {
                    addSuffix: true,
                  })}
                </td>
                <td>{p?.visit || 0}</td>
                <td>{p?.click || 0}</td>
                <td style={{ textTransform: "capitalize" }}>{p?.user?.name}</td>
                <td className="text-end">
                  <div className="admProp__actions">
                    <button className="iconBtn view">
                      <FiEye />
                    </button>
                    <button
                      onClick={() => editHandler(p)}
                      className="iconBtn edit"
                    >
                      <FiEdit />
                    </button>
                    <button
                      onClick={() => deleteHandler(p, i)}
                      className="iconBtn delete"
                    >
                      <FiTrash2 />
                    </button>
                    <button
                      disabled={p?.isHot === "hot"}
                      onClick={() => markHotHandler(p, i)}
                      className={`iconBtn ${p?.isHot}`}
                    >
                      <FaGripfire />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
